<template>
    <div class="payment-confirmation-page">
        <PageSpinner :onloader="onloader" />
        <div class="confirmation-card">
            <!-- Loading Bar -->
            <div class="loading-bar"></div>

            <!-- Background Elements -->
            <div class="background-elements">
                <div class="grid-pattern"></div>
                <div class="floating-orb"></div>
                <div class="floating-orb"></div>
                <div class="floating-orb"></div>
            </div>

            <div v-if="isConfirmed">
                <div class="success-indicator">
                    <div class="status-circle">
                        <div class="circle-outer"></div>
                        <div class="checkmark-container">
                            <svg class="checkmark" viewBox="0 0 52 52">
                                <path d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                            </svg>
                        </div>
                    </div>
                </div>

                <!-- Confirmation Content -->
                <div class="confirmation-content">
                    <h1 class="confirmation-title">Payment Confirmed</h1>
                    <p class="confirmation-message" ref="messageText">
                        {{ responseMessage }}
                    </p>

                </div>
            </div>
            <div v-else>
                <h1 class="confirmation-title"> Waiting '''</h1>
            </div>
            <!-- Success Indicator -->


            <!-- Status Indicators -->

        </div>
    </div>
</template>

<script>
import PageSpinner from "@/components/PageSpinner";
import Alert from "@/mixins/Alert.mixins";

export default {
    name: "PortalPaymentConfirmation",
    components: { PageSpinner },
    mixins: [Alert],
    data() {
        return {
            isConfirmed: false,
            responseMessage: "",
            onloader: "none",
        };
    },
    methods: {
        VerifySubscription(TransactionRef) {
            this.onloader = "flex";
            this.$store
                .dispatch("PortalStudentSubscription/VerifyPayment", TransactionRef)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.isConfirmed = true;
                        this.responseMessage = resp.data.responseMessage;
                    } else {
                        this.responseMessage = resp.data.responseMessage;
                    }
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        handleContinue(event) {
            this.createParticleEffect(event);
            setTimeout(() => {
                alert("✓ Payment confirmed. Redirecting to dashboard...");
            }, 800);
        },
        createParticleEffect(event) {
            const button = event.target;
            const rect = button.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            for (let i = 0; i < 12; i++) this.createParticle(centerX, centerY, i);
        },
        createParticle(x, y, index) {
            const particle = document.createElement("div");
            particle.className = "particle";
            const size = Math.random() * 6 + 3;
            const angle = (index / 12) * Math.PI * 2;
            const distance = 50 + Math.random() * 30;
            const duration = 1000 + Math.random() * 500;
            const hue = 210 + Math.random() * 30;
            const saturation = 70 + Math.random() * 20;
            const lightness = 60 + Math.random() * 20;
            particle.style.cssText = `
        width: ${size}px;
        height: ${size}px;
        background: hsl(${hue}, ${saturation}%, ${lightness}%);
        border-radius: ${size > 5 ? "50%" : "2px"};
        position: fixed;
        left: ${x}px;
        top: ${y}px;
        pointer-events: none;
        z-index: 1000;
        box-shadow: 0 0 ${size * 2}px hsl(${hue}, ${saturation}%, ${lightness}%);
      `;
            document.body.appendChild(particle);
            const endX = x + Math.cos(angle) * distance;
            const endY = y + Math.sin(angle) * distance;
            const animation = particle.animate(
                [
                    { transform: "translate(0, 0) scale(1) rotate(0deg)", opacity: 1 },
                    {
                        transform: `translate(${endX - x}px, ${endY - y}px) scale(0) rotate(360deg)`,
                        opacity: 0,
                    },
                ],
                { duration: duration, easing: "cubic-bezier(0.4, 0, 0.2, 1)" }
            );
            animation.onfinish = () => particle.remove();
        },
        startTypingEffect() {
            const messageElement = this.$refs.messageText;
            const originalText = messageElement.textContent;
            messageElement.textContent = "";
            setTimeout(() => {
                let i = 0;
                const typeWriter = setInterval(() => {
                    if (i < originalText.length) {
                        messageElement.textContent += originalText.charAt(i);
                        i++;
                    } else clearInterval(typeWriter);
                }, 35);
            }, 1200);
        },
        handleRipple(event) {
            const element = event.currentTarget;
            const rect = element.getBoundingClientRect();
            this.createRipple(element, rect.width / 2, rect.height / 2);
        },
        createRipple(element, x, y) {
            const ripple = document.createElement("div");
            ripple.style.cssText = `
        position: absolute;
        width: 20px;
        height: 20px;
        background: rgba(59, 130, 246, 0.3);
        border-radius: 50%;
        left: ${x - 10}px;
        top: ${y - 10}px;
        pointer-events: none;
        animation: ripple 0.6s ease-out;
      `;
            element.style.position = "relative";
            element.appendChild(ripple);
            setTimeout(() => ripple.remove(), 600);
        },
    },
    created() {
        const reference = this.$route.query.tx_ref;
        this.VerifySubscription(reference);
    },
    mounted() {
        this.startTypingEffect();
    },
};
</script>

<style>
/* 🌟 PAYMENT CONFIRMATION PAGE UNIQUE STYLES */
.payment-confirmation-page * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.payment-confirmation-page {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    color: #f8fafc;
    font-weight: 400;
}

.payment-confirmation-page .confirmation-card {
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 24px;
    padding: 70px 50px;
    text-align: center;
    box-shadow:
        0 25px 50px -12px rgba(0, 0, 0, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    max-width: 520px;
    width: 100%;
    position: relative;
    overflow: hidden;
}

/* Success Indicator */
.payment-confirmation-page .success-indicator {
    margin-bottom: 45px;
    position: relative;
}

.payment-confirmation-page .status-circle {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    position: relative;
}

.payment-confirmation-page .circle-outer {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: conic-gradient(from 0deg, #3b82f6 0%, #3b82f6 var(--progress, 0%), #334155 var(--progress, 0%), #334155 100%);
    position: relative;
    animation: payment-circleFill 1.8s cubic-bezier(0.22, 0.61, 0.36, 1) forwards;
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.2);
}

.payment-confirmation-page .circle-outer::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    background: #1e293b;
    border-radius: 50%;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
}

.payment-confirmation-page .checkmark-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 48px;
    height: 48px;
    opacity: 0;
    animation: payment-checkmarkReveal 0.5s ease 1.2s forwards;
}

.payment-confirmation-page .checkmark {
    width: 100%;
    height: 100%;
    stroke: #3b82f6;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
    stroke-dasharray: 60;
    stroke-dashoffset: 60;
    animation: payment-checkmarkDraw 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 1.4s forwards;
    filter: drop-shadow(0 2px 4px rgba(59, 130, 246, 0.3));
}

/* Content */
.payment-confirmation-page .confirmation-content {
    opacity: 0;
    transform: translateY(25px);
    animation: payment-contentReveal 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 1s forwards;
}

.payment-confirmation-page .confirmation-title {
    font-size: 36px;
    font-weight: 700;
    color: #f8fafc;
    margin-bottom: 20px;
    letter-spacing: -0.02em;
    background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.payment-confirmation-page .confirmation-message {
    font-size: 18px;
    color: #cbd5e1;
    line-height: 1.7;
    margin-bottom: 45px;
    font-weight: 400;
    max-width: 360px;
    margin-left: auto;
    margin-right: auto;
}

/* Button */
.payment-confirmation-page .action-button {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    color: white;
    border: none;
    padding: 18px 45px;
    border-radius: 14px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
    animation: payment-buttonReveal 0.6s ease 1.6s forwards;
    position: relative;
    overflow: hidden;
    box-shadow:
        0 4px 15px rgba(37, 99, 235, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.payment-confirmation-page .action-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
    transition: left 0.7s;
}

.payment-confirmation-page .action-button:hover {
    transform: translateY(-2px);
    box-shadow:
        0 12px 25px rgba(37, 99, 235, 0.4),
        0 6px 15px rgba(37, 99, 235, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.payment-confirmation-page .action-button:hover::before {
    left: 100%;
}

.payment-confirmation-page .action-button:active {
    transform: translateY(0);
}

/* Status Indicators */
.payment-confirmation-page .status-indicators {
    margin-top: 35px;
    display: flex;
    justify-content: center;
    gap: 25px;
    flex-wrap: wrap;
    opacity: 0;
    animation: payment-fadeInUp 0.6s ease 1.8s forwards;
}

.payment-confirmation-page .status-item {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #94a3b8;
    font-size: 14px;
    font-weight: 500;
    padding: 12px 18px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.payment-confirmation-page .status-icon {
    width: 18px;
    height: 18px;
    background: #3b82f6;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: white;
    flex-shrink: 0;
}

/* Background Effects */
.payment-confirmation-page .background-elements {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: -1;
}

.payment-confirmation-page .floating-orb {
    position: absolute;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(59, 130, 246, 0.15) 0%, transparent 70%);
    filter: blur(25px);
    animation: payment-float 10s ease-in-out infinite;
}

.payment-confirmation-page .floating-orb:nth-child(1) {
    width: 140px;
    height: 140px;
    top: -50px;
    left: -50px;
    animation-delay: 0s;
}

.payment-confirmation-page .floating-orb:nth-child(2) {
    width: 100px;
    height: 100px;
    bottom: -30px;
    right: 15%;
    animation-delay: 3s;
}

.payment-confirmation-page .floating-orb:nth-child(3) {
    width: 80px;
    height: 80px;
    top: 40%;
    right: -30px;
    animation-delay: 6s;
}

.payment-confirmation-page .grid-pattern {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image:
        linear-gradient(rgba(59, 130, 246, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(59, 130, 246, 0.03) 1px, transparent 1px);
    background-size: 30px 30px;
    opacity: 0.3;
}

/* Loading Bar */
.payment-confirmation-page .loading-bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 3px;
    background: linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd);
    width: 0%;
    animation: payment-loadingComplete 1.5s ease 0.2s forwards;
    box-shadow: 0 0 10px rgba(59, 130, 246, 0.5);
}

/* Particles */
.payment-confirmation-page .particle {
    position: absolute;
    pointer-events: none;
    opacity: 0;
}

/* --- ANIMATIONS (namespaced) --- */
@keyframes payment-circleFill {
    0% {
        --progress: 0%;
    }

    100% {
        --progress: 100%;
    }
}

@keyframes payment-checkmarkReveal {
    to {
        opacity: 1;
    }
}

@keyframes payment-checkmarkDraw {
    to {
        stroke-dashoffset: 0;
    }
}

@keyframes payment-contentReveal {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes payment-buttonReveal {
    to {
        opacity: 1;
    }
}

@keyframes payment-fadeInUp {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes payment-float {

    0%,
    100% {
        transform: translateY(0px) rotate(0deg) scale(1);
    }

    33% {
        transform: translateY(-25px) rotate(120deg) scale(1.08);
    }

    66% {
        transform: translateY(15px) rotate(240deg) scale(0.92);
    }
}

@keyframes payment-loadingComplete {
    to {
        width: 100%;
    }
}

/* --- RESPONSIVE --- */
@media (max-width: 568px) {
    .payment-confirmation-page .confirmation-card {
        padding: 50px 30px;
        margin: 15px;
    }

    .payment-confirmation-page .confirmation-title {
        font-size: 32px;
    }

    .payment-confirmation-page .confirmation-message {
        font-size: 17px;
        margin-bottom: 35px;
    }

    .payment-confirmation-page .status-circle {
        width: 100px;
        height: 100px;
    }

    .payment-confirmation-page .checkmark-container {
        width: 40px;
        height: 40px;
    }

    .payment-confirmation-page .status-indicators {
        gap: 15px;
    }

    .payment-confirmation-page .status-item {
        padding: 10px 15px;
        font-size: 13px;
    }
}

@media (max-width: 400px) {
    .payment-confirmation-page .confirmation-card {
        padding: 40px 25px;
    }

    .payment-confirmation-page .confirmation-title {
        font-size: 28px;
    }

    .payment-confirmation-page .confirmation-message {
        font-size: 16px;
    }

    .payment-confirmation-page .action-button {
        padding: 16px 35px;
        font-size: 15px;
    }
}
</style>
